module.exports = __webpack_public_path__ + "ec7c5841f010d57acbbcbb101d1294f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/whole_foods_2023_chart.png
// module id = 1761
// module chunks = 0